import { gql } from "@apollo/client"

export const GET_OPTIONS = gql`
  query GetOptions {
    getOptions {
      id
      name
      image
    }
  }
`